<greco-simple-dialog [data]="dialogData">
  <greco-zoom-resource-input *ngIf="formGroup.value.type === 'Zoom'"></greco-zoom-resource-input>
  <greco-person-resource-input *ngIf="formGroup.value.type === 'Person'"></greco-person-resource-input>
</greco-simple-dialog>
